module.exports = __webpack_public_path__ + "static/media/00_insti_mobile.7c06de77.jpg";